export default function ExternalLink(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.6667 1.66667H5.00004C4.55801 1.66667 4.13409 1.84227 3.82153 2.15483C3.50897 2.46739 3.33337 2.89131 3.33337 3.33334V16.6667C3.33337 17.1087 3.50897 17.5326 3.82153 17.8452C4.13409 18.1577 4.55801 18.3333 5.00004 18.3333H15C15.4421 18.3333 15.866 18.1577 16.1786 17.8452C16.4911 17.5326 16.6667 17.1087 16.6667 16.6667V6.66667M11.6667 1.66667L16.6667 6.66667M11.6667 1.66667V6.66667H16.6667M10 15V10M7.50004 12.5H12.5"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
